import { Container } from "react-bootstrap";
import './footer.css';
function Footer(){
    return(
        <footer style={{backgroundColor:'#262626',textAlign:'center',padding:'10px'}}>
            <Container>
                <h3 style={{margin:'0',color:'white', fontWeight:'bold'}}>Created By Ahmed Sdek </h3>
            </Container>
        </footer>
    )
}

export default Footer;